import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { type PrizeNameProps } from './types';

import s from './index.module.scss';

export const PremiumPrizeName = ({ prize }: PrizeNameProps) => {
  const { t } = useTranslation();

  const isPartOnly = prize.partSize < 1;

  return (
    <>
      {isPartOnly && <div className={s.subtitle}>{t('Part of')}</div>}
      <div className={s.name}>{prize.name}</div>
      {isPartOnly && (
        <div className={clsx(s.description, s.fill)}>
          {t('Your progress')}:{' '}
          <span className={s.value}>{prize.collectedPartsCount}%</span>
        </div>
      )}
    </>
  );
};
